<template>
  <div id="app">
    <!-- 可以添加全局导航菜单或头部信息 -->
    <router-view></router-view>
    <!-- 可以添加页脚信息 -->
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* 全局样式 */
body, html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}

#app {
  text-align: center;
}

/* 其他全局样式 */
</style>



// WEBPACK FOOTER //
// src/App.vue